export class CompleteUploadRequestDto {
  uuid: string;

  constructor(uuid: string) {
    this.uuid = uuid;
  }
}
